(function () {
	'use strict';

	angular
		.module('wizard-future7.directives')
		.directive('dummy', Dummy)

	/** @ngInject */
	function Dummy(PATHS) {
		function DummyController($rootScope, $scope, $timeout, HelperService) {
			const vm = this;

			let removeWatchDummyHair = $scope.$watchGroup(['vm.dummyHairStyle', 'vm.dummyHairColor'], (oldvalue, newvalue) => {
				if (newvalue) {
					vm.dummyHairStyleApplied = null;
					vm.dummyHairColorApplied = null;

					$timeout(() => {
						vm.dummyHairStyleApplied = newvalue[0];
						vm.dummyHairColorApplied = newvalue[1];
					}, 200)
				}
			})

			$scope.$on('$destroy', () => {
				removeWatchDummyHair();
			})

			initVars();

			function initVars() {
				vm.dummyBody = $rootScope.dummyBody;
				vm.dummyEyeStyle = $rootScope.dummyEyeStyle;
				vm.dummyEyeColor = $rootScope.dummyEyeColor;
				vm.dummyHairStyle = $rootScope.dummyHairStyle;
				vm.dummyHairColor = $rootScope.dummyHairColor;
				vm.dummyGlasses = $rootScope.dummyGlasses;
				vm.dummyName = $rootScope.dummyName;
				vm.dummyNameScheme = $rootScope.dummyNameScheme || 'light';

				vm.changeEye = false;
				vm.changeHair = false;
				vm.changeGlasses = false;
			}

		}

		return {
			bindToController: true,
			controller: DummyController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/dummy/dummy.html`,
			scope: {
				dummyBody: '=',
				dummyEyeStyle: '=',
				dummyEyeColor: '=',
				dummyHairStyle: '=',
				dummyHairColor: '=',
				dummyGlasses: '=',
				dummyName: '=',
				dummyNameScheme: '='
			}
		}
	}
}());